export default "__VITE_ASSET__CiX_aCbw__"